<template>
  <div>
    <Can I="delete" a="/lisans/Lisans">
      <b-modal
        id="modal-lisans-delete"
        centered
        title="Lisans Sil"
        ok-title="Sil"
        ok-variant="danger"
        header-bg-variant="danger"
        header-text-variant="white"
        cancel-title="İptal"
        cancel-variant="outline-secondary"
        @ok.prevent="remove"
        :busy="overlay">
        <p>{{ getMessage(342) }}</p>
      </b-modal>
    </Can>
    <Can I="read" a="/lisans/LisansLog">
      <b-modal
        id="modal-log"
        size="lg"
        centered
        title="Loglar"
        ok-variant="secondary"
        ok-title="Kapat"
        ok-only
        :busy="$store.state.general.showOverlay"
        @hidden="clearLogForm">
        <div>
          <form>
            <div class="row">
              <div class="col-sm-5">
                <div class="form-group">
                    <label>Başlık</label>
                    <input type="text" class="form-control" v-model="logForm.parameter1" maxlength="128">
                </div>
              </div>
              <div class="col-sm-5">
                <div class="form-group">
                    <label>Kullanıcı Adı</label>
                    <input type="text" class="form-control" v-model="logForm.userName" maxlength="64">
                </div>
              </div>
              <div class="col-sm-2">
                <button class="btn btn-block btn-outline-secondary mt-4" type="button" @click="getLogModal">Listele</button>
              </div>
            </div>
          </form>
          <div class="table-responsive" style="max-height:500px;">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>İşlem Tarihi</th>
                    <th class="fit">Eser Id</th>
                    <th class="fit">İşlem</th>
                    <th class="fit">Kolon Adı</th>
                    <th class="fit">Tablo Adı</th>
                    <th>Eski Değer</th>
                    <th>Yeni Değer</th>
                    <th class="fit">Kullanıcı Adı</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in log.liste" :key="index"  class="cursor-pointer">
                    <td>{{ item.modTime | moment("DD/MM/YYYY") }}</td>
                    <td class="fit">{{ item.eserID }}</td>
                    <td class="fit">{{ getLogAction(item.action) }}</td>
                    <td class="fit">{{ item.columnName }}</td>
                    <td class="fit">{{ item.tableName }}</td>
                    <td>{{ item.oldValue }}</td>
                    <td>{{ item.newValue }}</td>
                    <td class="fit">{{ item.userName }}</td>
                  </tr>
                </tbody>
              </table>
          </div>
          <div class="alert alert-danger text-center" v-if="showError">{{ errorMessage }}</div>
          <div class="row" v-if="log.liste.length > 0">
            <div class="col">
              <i class="text-secondary">{{ log.sayfalama.totalItems }} kayıttan {{ ((logForm.pageNum - 1) * logForm.pageSize) + 1 }} - {{ logForm.pageNum * logForm.pageSize }} arası gösterilmektedir</i>
            </div>
            <div class="col">
              <div class="row">
                <div class="col d-flex justify-content-end">
                  <nav>
                    <paginate v-if="log.liste.length"
                              :page-count="log.sayfalama.totalPages"
                              :click-handler="changeLogPage"
                              :prev-text="'Önceki'"
                              :next-text="'Sonraki'"
                              :active-class="'active'"
                              :container-class="'pagination'"
                              v-model="logForm.pageNum">
                    </paginate>
                  </nav>
                </div>
                <div class="col-2">
                  <select v-select class="form-control" v-model="logForm.pageSize" @change="changeLogSize">
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </Can>
    <div class="standart-page">
      <div class="row">
        <div class="col"></div>
        <div class="col"><h3 class="title">LİSANSLAR</h3></div>
        <div class="col d-flex justify-content-end align-items-start">
          <Can I="create" a="/lisans/Lisans">
            <button class="btn btn-danger" @click="$router.push('lisans/detay')"><font-awesome-icon icon="plus" size="lg"></font-awesome-icon> Yeni Lisans</button>
          </Can>
        </div>
      </div>
      <div class="card-component mb-5">
        <div class="body">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label>Başlık</label>
                <input type="text" class="form-control" v-model="form.baslik" maxlength="128">
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label>Lisans ID</label>
                <input type="text" class="form-control" v-model="form.lisansId" v-mask="'#######'">
              </div>
            </div>
            <div class="col-sm-3" v-if="$store.state.auth.user.mbId === 0">
              <div class="form-group">
                <label>Meslek Birliği</label>
                <select v-select
                    class="form-control"
                    v-model="form.mbId">
                  <option :value="0">Seçiniz</option>
                  <option :value="item.id"
                      v-for="(item,index) in mblist"
                      :key="index">
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="footer d-flex justify-content-end">
          <Can I="read" a="/lisans/LisansLog">
            <button class="btn btn-outline-secondary mt-4" v-b-modal.modal-log>Log</button>
          </Can>
          <button class="btn btn-outline-secondary mt-4" @click="clear">Temizle</button>
          <button class="btn btn-secondary mt-4" @click="search">Listele</button>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Lisans ID</th>
              <th>Başlık</th>
              <th class="fit">Tipi</th>
              <th class="fit" v-if="$store.state.auth.user.mbId === 0">Meslek Birliği</th>
              <th class="fit text-right"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in $store.state.lisans.lisans.liste" :key="index" class="cursor-pointer" @click="$router.push('/lisans/detay/' + item.recordId)">
              <td>{{ item.recordId }}</td>
              <td>{{ item.baslik }}</td>
              <td class="fit">{{ getOptionWithParams(item.tipi, "lisansTurListe") }}</td>
              <td class="fit" v-if="$store.state.auth.user.mbId === 0">{{ item.mbName }}</td>
              <td class="fit text-right">
                  <Can I="delete" a="/lisans/Lisans">
                      <button class="btn btn-sm btn-outline-secondary" @click.stop="showDeleteModal(item)">
                          <font-awesome-icon icon="trash-alt" size="lg"></font-awesome-icon>
                      </button>
                  </Can>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="alert alert-danger text-center" v-if="showError">{{ errorMessage }}</div>
      <div class="row" v-if="$store.state.lisans.lisans.liste.length > 0 && !showError">
        <div class="col">
          <i class="text-secondary">{{ $store.state.lisans.lisans.sayfalama.totalItems }} kayıttan {{ ((form.pageNum - 1) * form.pageSize) + 1 }} - {{ form.pageNum * form.pageSize }} arası gösterilmektedir</i>
        </div>
        <div class="col">
          <div class="row">
            <div class="col d-flex justify-content-end">
              <nav>
                <paginate v-if="$store.state.lisans.lisans.liste.length"
                          :page-count="$store.state.lisans.lisans.sayfalama.totalPages"
                          :click-handler="changePage"
                          :prev-text="'Önceki'"
                          :next-text="'Sonraki'"
                          :active-class="'active'"
                          :container-class="'pagination'"
                          v-model="form.pageNum">
                </paginate>
              </nav>
            </div>
            <div class="col-2">
              <select class="form-control" v-model="form.pageSize" @change="changeSize">
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import {required} from "vuelidate/lib/validators";

export default {
  data() {
    return {
      prevRoute:null,
      errorMessage:'',
      showError: false,
      mblist:[],
      overlay: false,
      form: {
        mbId:this.$store.state.auth.user.mbId || 0,
        baslik:"",
        lisansId:"",
        pageNum: 1,
        pageSize: 25

      },
      fileUploadForm: {
        link:"",
        fileName:""
      },
      log: {
        liste: [],
        sayfalama: {}
      },
      logForm:{
        mbId:this.$store.state.auth.user.mbId,
        userName:"",
        parameter1:"",
        pageNum: 1,
        pageSize: 25
      }
    }
  },
  validations: {
    fileUploadForm:{
      link: {
        required
      },
      fileName: {
        required
      }
    }
  },
  methods: {
    ...mapActions('general', ['showModal', 'errorHandling', 'fileUpload']),
    ...mapActions('uye', ['getMBList']),
    ...mapActions('lisans', ["searchLisans", "deleteLisans", "getLog"]),
    clear() {
      this.$store.state.lisans.searchList = false;
      this.$store.state.lisans.lisans = Object.assign({}, {
        liste: [],
        sayfalama: {}
      });
      this.form = Object.assign({}, {
        mbId:this.$store.state.auth.user.mbId || 0,
        baslik:"",
        lisansId:"",
        pageNum: 1,
        pageSize: 25
      });
      this.$store.state.lisans.duplicateForm = Object.assign({}, this.form);
      this.showError = false;

    },
    changeSize() {
      this.list();
    },
    changePage(pageNumber) {
      this.form.pageNum = pageNumber;
      this.list();
    },
    search(){
      this.form.pageNum = 1;
      this.list();
    },
    list() {
      this.$store.state.lisans.lisans.liste = [];
      if (this.isEmptyFilterForm()) {
        this.showError = true;
        this.errorMessage = this.getMessage(140);
        return;
      }
      this.$store.state.lisans.duplicateForm = Object.assign({}, this.form);
      this.$store.state.general.showOverlay = true;
      this.showError = false;

      let data = Object.assign({}, this.form);
      data.mbId = data.mbId || 0;
      
      this.searchLisans(data).then(res => {
        this.$store.state.general.showOverlay = false;
        if(res.errorCode !== 0 && res.errorCode !== 118){
          this.errorHandling(res);
          return;
        }
        if ((res.data && res.data.liste.length === 0) || !res.data) {
          this.showError = true;
          this.errorMessage = this.getMessage(118);
          this.$store.state.lisans.searchList = true;
        }else{
          this.showError = false;
          this.errorMessage = "";
          this.$store.state.lisans.searchList = true;
          let list = Object.assign([], this.$store.state.lisans.lisans.liste);
          list.liste.forEach(element => {
            element.mbName = this.mblist.filter(x => x.id == element.parentIdNavigation.mbId)[0].name;
          });
          this.$store.state.lisans.lisans.liste = list;
        }
      }).catch(() => {
        this.$store.state.general.showOverlay = false;
      });
    },
    showDeleteModal(item) {
      this.$store.state.lisans.removeItem = item;
      this.$bvModal.show('modal-lisans-delete');
    },
    remove() {
      this.$store.state.general.showOverlay = true;
      this.deleteLisans(this.$store.state.lisans.removeItem.recordId).then((res) => {
        this.$store.state.general.showOverlay = false;
        this.$bvModal.hide('modal-lisans-delete');
        if(res.errorCode == 0){
          this.list();
        }else{
          this.errorHandling(res);
        }
      }).catch((err) => {
        this.showModal({title: 'Hata!', message: err, type: 'danger'});
        this.$store.state.general.showOverlay = false;
      });
    },
    getMBListOptions(){
      if(this.$store.state.auth.user.mbId !== 0)
        return;

      this.$store.state.general.showOverlay = true;
      this.getMBList().then(res => {
        if(res.errorCode == 0){
            this.mblist = res.data;
        }else{
            this.errorHandling(res);
        }
        this.$store.state.general.showOverlay = false;
      });
    },
    isEmptyFilterForm() {
      this.formTrimCheck(this.form);
      return (this.$store.state.auth.user.mbId !== 0 || this.form.mbId === 0)
      && this.form.baslik === ''
      && this.form.lisansId === '';
    },
    getLogModal(){
      this.log.liste = [];
      this.getLog(this.logForm).then(res => {
        this.$store.state.general.showOverlay = false;
        if(res.errorCode !== 0 && res.errorCode !== 118){
          this.errorHandling(res);
          return;
        }
        if ((res.data && res.data.liste.length === 0) || !res.data) {
          this.showError = true;
          this.errorMessage = this.getMessage(118);
        }else{
          this.log = res.data;

          this.showError = false;
          this.errorMessage = "";
        }
      }).catch(() => {
        this.$store.state.general.showOverlay = false;
      });
    },
    changeLogPage(pageNumber) {
      this.logForm.pageNum = pageNumber;
      this.getLogModal();
    },
    changeLogSize() {
      this.logForm.pageNum = 1;
      this.getLogModal();
    },
    clearLogForm(){
      this.log.liste = [];
      this.logForm.userName = "";
      this.logForm.parameter1 = "";
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  created() {
    this.getMBListOptions();
  },
  watch: {
    prevRoute(nw) {
      if (nw.name === 'lisans-detay' || nw.name === 'lisans-detay-id') {
        if (Object.keys(this.$store.state.lisans.duplicateForm).length > 0) {
          this.form = Object.assign({}, this.$store.state.lisans.duplicateForm);
          if(this.$store.state.lisans.searchList){
            this.list();
          }
        }
      } else {
        this.clear();
      }
    }
  },
  computed: {
    ...mapGetters('general', ['getMessage', 'getOptionWithParams', 'getFileLink', 'getLogAction', 'formTrimCheck'])
  }
};
</script>